import { render, staticRenderFns } from "./ModalAwaitPayment.vue?vue&type=template&id=255f24e9&scoped=true&"
import script from "./ModalAwaitPayment.vue?vue&type=script&lang=js&"
export * from "./ModalAwaitPayment.vue?vue&type=script&lang=js&"
import style0 from "./ModalAwaitPayment.vue?vue&type=style&index=0&id=255f24e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255f24e9",
  null
  
)

export default component.exports